import * as React from "react";
import reservationStore from "../../store/reservationStore";
import { useEffect } from "react";
import api from "../../utils/api";

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Stack from '@mui/material/Stack';
import { getDayOfWeek } from "../../utils/util";
import CircleIcon from '@mui/icons-material/Circle';



const hospitalParam = {
  cusId: '',
  famId: '',
  hosId: ''
}

const SetFinish = (props: any) => {
  const storeData: any = reservationStore();
  const [selectHospital, setSelectHospital] = React.useState({
    name: '', address: '', buildingNum: '', phone: '', notice: '', plusInfo: '', fileName: ''
  });
  const [uniqueKeys, setUniqueKeys] = React.useState([]);

  useEffect(() => {
    hospitalParam.cusId = decodeURIComponent(localStorage.getItem("userCusID") || '');
    hospitalParam.famId = decodeURIComponent(storeData.reservationInfo.famId);
    hospitalParam.hosId = decodeURIComponent(storeData.reservationInfo.hosId);

    // 선택한 병원 정보
    api.post('customer/api/v1/CU_003_003_2', hospitalParam).then(res => {
      localStorage.setItem('HOS_INFO', JSON.stringify(res.data));
      setSelectHospital(res.data)
    }).catch(function (error) {
      console.log(error)
    });
    
    // 선택항목
    const keys = storeData.checkedInjectioList.map((v: any) => v.ipClass);
    setUniqueKeys(keys.filter((value: any, index: any, self: any) => self.indexOf(value) === index));

  }, []);

  return (
    <Container sx={{ p: 0, pb: 12 }}>
      <Card sx={{ minWidth: 320, bgcolor: '#FFFBF8', pb: 5 }}>
        <CardMedia
          component="img"
          sx={{ height: 180 }}
          src={selectHospital['fileName']}
          title="img"
        />
        <Stack direction="row" alignItems="center" justifyContent='center' sx={{mt:3}}>
          <CheckCircleOutlineIcon fontSize="large" sx={{ bgcolor: '#EF8322', borderRadius: '50%', p: 1, color: '#fff', border: '7px solid #fff', mb: -4 }} />
        </Stack>
        <CardContent sx={{ m: '0 auto', mb: 0, bgcolor: '#fff', width: 320, minWidth: 320, boxShadow: '0 -3px 5px rgba(0,0,0,.2)', boxSizing: 'border-box' }}>
          <Box sx={{ width: '100%', mt: 3 }}>
            <Typography color="#333" fontWeight={700} fontSize={18} align="center">
              {props.finishSendItems.userName}님
            </Typography>
            <Typography color="#EF8322" align="center" fontWeight={700} sx={{ mt: 1 }}>
              예약 신청이 완료되었습니다!
            </Typography>
            <Divider sx={{ mt: 2 }} />
            <Divider sx={{ mt: .5 }} />

            <Typography variant="body1" color="#666" fontWeight={700} fontSize={18} align="center" sx={{ mt: 2 }}>
              {selectHospital['name']}
            </Typography>
            <Typography variant="body1" color="#666" fontWeight={700} fontSize={16} align="center" sx={{ mt: 1 }}>
              {storeData.reservationInfo.date.replaceAll('-', '.') + '.(' + getDayOfWeek(storeData.reservationInfo.date) + ')'}
            </Typography>
            <Divider sx={{ mt: 2 }} />
            <Divider sx={{ mt: .5 }} />
          </Box>

          <Box sx={payBoxStyle}>
            <List sx={payListStyle}>
              <ListItem >
                병원
              </ListItem>
              <ListItem>
                패키지
              </ListItem>
              <ListItem>
                선택검사
              </ListItem>
            </List>

            <List sx={payStyle} className="pay">
              <ListItem>
                {selectHospital['name']}
              </ListItem>
              <ListItem >
                {storeData.pakageInfo['result']['name']}
              </ListItem>
              <ListItem sx={addOption}>
                {uniqueKeys.map((uniqueKey: any) => (
                  storeData.checkedInjectioList.filter((v: any) => v.ipClass === uniqueKey).map((ij: any, index: any) => (
                    <React.Fragment key={index}>
                      {index === 0 ? <Typography component={'li'}>[{ij.ipClass}]</Typography> : null}
                      <Typography component={'li'} fontSize={13}>{ij.inspection}</Typography>
                    </React.Fragment>
                  ))
                ))}
              </ListItem>
            </List>
          </Box>
          <Divider component="div" sx={{ mt: 2, mb: 2 }} />


          <Box sx={payBoxStyle}>
            <List sx={payListStyle}>
              <ListItem sx={{ color: "#080484", fontWeight: 700 }}>
                검진 예약 번호
              </ListItem>
            </List>
            <List sx={payStyle}>
              <ListItem sx={{ color: "#EF8322", fontWeight: 700, }}>
                {props.finishSendItems.reservationId}
              </ListItem>
            </List>
          </Box>

          <Divider component="div" sx={{ mt: 2 }} />
          <Divider sx={{ mt: .5 }} />

          <Box sx={{ width: '100%', mt: 2, pb: 5 }}>
            <Typography variant="body1" color="#EF8322" align="center" fontWeight={700} fontSize={14} sx={{}} >
              예약 담당자 확인 후 예약이 확정 됩니다.
            </Typography>
          </Box>

        </CardContent>
        <Stack direction={'row'} justifyContent={'center'} spacing={0} sx={{ m: '0 auto', width: 320, minWidth: 320, mt: '0px' }}>
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
        </Stack>
      </Card>
    </Container>
  );
}

const payBoxStyle = {
  p: 0,
  width: '100%',
  maxWidth: 320,
  display: 'flex',
  margin: '10px 0',
};

const payListStyle = {
  p: 0,
  width: '65%',
  fontSize: 14,
  '& li': { pr: 0 }
};

const payStyle = {
  p: 0,
  width: '100%',
  fontSize: 14,
  fontWeight: 700,
  '& li': {
    pl: 0,
  }

};

const addOption = {
  p: 0,
  width: '100%',
  flexDirection: 'column',
  alignItems: 'flex-start',
  '& li': {
    fontSize: 14,
    fontWeight: 700,
    pr: 1,
    pb: 1,
  },
  '& li:first-child': {
    pt: 1,
    pb: 1,

  }
};



const topCircle = {
  color: '#fff',
  boxShadow: '0 4px 2px rgba(0,0,0,.2)',
  borderRadius: '50%',
  mt: '-18px',
  fontSize: 14
}

const bottomCircle = {
  color: '#fffbf8',
  boxShadow: '0 -4px 2px rgba(0,0,0,.2)',
  borderRadius: '50%',
  mt: '-10px',
  fontSize: 14
}



export default SetFinish;
